import { Stack, StackProps, styled } from '@mui/material';

import clsx from 'clsx';

import { hexToRgba } from '../../../../../../utils/color';
import { generateClasses } from '../../../../../../utils/helper';

export const publishedQuestionOptionsClasses = generateClasses('PublishedQuestionOptions', [
  'barGraph',
  'pieChart',
  'overlay',
]);

export const Root = styled((props: StackProps) => <Stack justifyContent="center" gap={2} {...props} />)(
  ({ theme }) => ({
    position: 'relative',
    [`& .${publishedQuestionOptionsClasses.barGraph}`]: {
      flex: 1,
    },
    [`& .${publishedQuestionOptionsClasses.pieChart}`]: {
      flex: 1,
    },
    [`& .${publishedQuestionOptionsClasses.overlay}`]: {
      position: 'absolute',
      inset: 0,
      zIndex: 1,
    },
  })
);

export const Overlay = styled((props: StackProps) => (
  <Stack
    justifyContent="center"
    alignItems="center"
    {...props}
    className={clsx(publishedQuestionOptionsClasses.overlay, props.className)}
  />
))(({ theme }) => ({
  backgroundColor: hexToRgba(theme.palette.common.white, 0.8),
}));
